import { SOLARCONTRACT_URL } from "../../API/Api";
import axios from "axios";
import SolarReducer from "./SolarSlice";

const GetAllSolarContractsMethod = async (data, token) => {
    const headers = {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
    };

    const response = await axios({
        method: "GET",
        headers:headers,
        baseURL: `${SOLARCONTRACT_URL}`,
        params: { ...data },
    });

    return response.data;
};
const SolarAnalysis = async (data, token) => {
    const headers = {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
    };

    const response = await axios({
        method: "GET",
        headers:headers,
        baseURL: `${SOLARCONTRACT_URL}/dashboard/analysis`,
        params: { year_analysis: "2022" },
    });

    return response.data;
};

const SolarService = {
    GetAllSolarContractsMethod,
    SolarAnalysis,
};

export default SolarService;
